<template>
  <div class="bg-white rounded-md shadow-md">
    <div class="p-3 border-b-2 border-dashed">
      <div class="flex justify-start gap-2 items-center w-full">
        <div
          class="flex justify-center items-center rounded-md w-7 h-7 bg-green-100"
        >
          <img
            src="../../../assets/icon/elektrifikasi-inactive.png"
            alt="icon"
            class="w-4 h-auto"
          />
        </div>
        <h5 class="text-xs font-semibold">Daya yang digunakan</h5>
      </div>
    </div>
    <div class="px-4">
      <div class="grid grid-cols-4 gap-5 py-3">
        <div class="arrow-border relative inline-block h-10 w-full bg-gray-400">
          <div
            class="arrow-content absolute bg-white flex justify-center items-center"
          >
            <h5 class="font-medium text-slate-700 text-xs">Sumber Energy</h5>
          </div>
        </div>
        <div class="arrow-border relative inline-block h-10 w-full bg-gray-400">
          <div
            class="arrow-content absolute bg-white flex justify-center items-center"
          >
            <h5 class="font-medium text-slate-700 text-xs text-center">
              Conversi ke Energy <br />Satuan : Juta Mega Joule
            </h5>
          </div>
        </div>
        <div class="arrow-border relative inline-block h-10 w-full bg-gray-400">
          <div
            class="arrow-content absolute bg-white flex justify-center items-center"
          >
            <h5 class="font-medium text-slate-700 text-xs text-center">
              Conversi ke Energy <br />Satuan : Juta Liter
            </h5>
          </div>
        </div>
        <div class="arrow-border relative inline-block h-10 w-full bg-gray-400">
          <div
            class="arrow-content absolute bg-white flex justify-center items-center"
          >
            <h5 class="font-medium text-slate-700 text-xs text-center">
              Conversi ke Emisi <br />
              Satuan : Ribu TonCO2e
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div class="px-4 border-b-2">
      <div class="h-56 w-full grid grid-cols-4 gap-5 relative">
        <div
          class="flex justify-center items-end w-full h-full transition"
          v-for="power in data"
          :key="power.type"
        >
          <div class="w-1/3 max-w-20 h-full relative">
            <v-tooltip
              :text="formatFloat(power.power_installed)"
              location="top"
            >
              <template v-slot:activator="{ props }">
                <div
                  v-bind="props"
                  class="w-full bg-green-400 absolute flex justify-center items-center"
                  :style="{
                    height: power.power_installed_px + 'px',
                    bottom:
                      power.electrification_used_px +
                      power.renewable_px +
                      power.fuel_useage_px +
                      'px',
                  }"
                  :class="{
                    hidden: power.power_installed === 0,
                  }"
                >
                  <span
                    class="text-black font-semibold text-[8px] px-1 py-[1px] bg-green-400 rounded-xl z-10"
                    :class="{ hidden: power.power_installed === 0 }"
                  >
                    {{ formatFloat(power.power_installed) }}
                  </span>
                </div>
              </template>
            </v-tooltip>
            <div
              class="w-full bg-green-400 absolute bottom-0"
              :style="{
                height: power.fuel_useage_px + 'px',
              }"
              :class="{
                hidden: power.power_installed === 0,
              }"
            ></div>
            <v-tooltip
              :text="formatFloat(power.electrification_used)"
              location="top"
            >
              <template v-slot:activator="{ props }">
                <div
                  v-bind="props"
                  class="w-full bg-emerald-600 absolute flex justify-center items-center"
                  :style="{
                    height: power.electrification_used_px + 'px',
                    bottom: power.renewable_px + power.fuel_useage_px + 'px',
                  }"
                  :class="{
                    hidden: power.electrification_used === 0,
                  }"
                >
                  <span
                    class="text-black font-semibold text-[8px] px-1 py-[1px] bg-emerald-600 rounded-xl z-10"
                    :class="{ hidden: power.electrification_used === 0 }"
                  >
                    {{ formatFloat(power.electrification_used) }}
                  </span>
                </div>
              </template>
            </v-tooltip>
            <div
              class="w-full absolute bottom-0 bg-emerald-600"
              :style="{
                height: power.renewable_px + power.fuel_useage_px + 'px',
              }"
              :class="{
                hidden: power.electrification_used === 0,
              }"
            ></div>
            <v-tooltip :text="formatFloat(power.renewable)" location="top">
              <template v-slot:activator="{ props }">
                <div
                  v-bind="props"
                  class="w-11/12 bg-orange-200 absolute left-1/2 -translate-x-1/2 flex justify-center items-center z-10"
                  :style="{
                    height:
                      power.fuel_useage !== 0
                        ? power.renewable_px + 'px'
                        : power.fuel_useage_px + power.renewable_px + 'px',
                    bottom:
                      power.fuel_useage !== 0
                        ? power.fuel_useage_px + 'px'
                        : 0 + 'px',
                  }"
                  :class="{
                    hidden: power.renewable === 0,
                  }"
                >
                  <span
                    class="text-black font-semibold text-[8px] px-1 py-[1px] bg-orange-200 rounded-xl"
                    :class="{ hidden: power.renewable === 0 }"
                  >
                    {{ formatFloat(power.renewable) }}
                  </span>
                </div>
              </template>
            </v-tooltip>
            <v-tooltip :text="formatFloat(power.fuel_useage)" location="top">
              <template v-slot:activator="{ props }">
                <div
                  v-bind="props"
                  class="w-11/12 bg-red-600 absolute bottom-0 left-1/2 -translate-x-1/2 flex justify-center items-center"
                  :style="{
                    height: power.fuel_useage_px + 'px',
                  }"
                  :class="{
                    hidden: power.fuel_useage === 0,
                  }"
                >
                  <span
                    class="text-black font-semibold text-[8px] px-1 py-[1px] bg-red-600 rounded-xl z-10"
                    :class="{ hidden: power.fuel_useage === 0 }"
                  >
                    {{ formatFloat(power.fuel_useage) }}
                  </span>
                </div>
              </template>
            </v-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-4 gap-5 w-full px-4">
      <h4 class="text-center text-xs text-gray-600 font-medium">
        Fuel (x10^6 Liter)
      </h4>
      <h4 class="text-center text-xs text-gray-600 font-medium">
        Joule (x 10^6 MJ)
      </h4>
      <h4 class="text-center text-xs text-gray-600 font-medium">
        Fuel (x 10^6 Liter)
      </h4>
      <h4 class="text-center text-xs text-gray-600 font-medium">
        Emisi (x 10^3 TonCO2e)
      </h4>
    </div>
    <div class="grid grid-cols-4 gap-5 w-full px-4 h-10">
      <div class="flex gap-2 items-center">
        <div class="w-2 min-w-2 min-h-2 h-2 bg-red-600"></div>
        <span class="text-[10px] mt-[3px]"> Penggunaan Fuel (Juta Liter) </span>
      </div>
      <div class="flex gap-2 items-center">
        <div class="w-2 min-w-2 min-h-2 h-2 bg-orange-200"></div>
        <span class="text-[10px] mt-[3px]"> Energi Terbarukan (MW) </span>
      </div>
      <div class="flex gap-2 items-center">
        <div class="w-2 min-w-2 min-h-2 h-2 bg-green-400"></div>
        <span class="text-[10px] mt-[3px]">
          Elektrifikasi Terpasang (MW/Thn)
        </span>
      </div>
      <div class="flex gap-2 items-center">
        <div class="w-2 min-w-2 min-h-2 h-2 bg-emerald-600"></div>
        <span class="text-[10px] mt-[3px]">
          Elektrifikasi Terpakai BIB All Area (MW/YTD)
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatFloat } from "@/utilities/helpers";

export default {
  name: "CardPowerUsedComponent",
  props: {
    data: Array,
  },
  methods: {
    formatFloat,
  },
};
</script>

<style scoped>
.arrow-border {
  clip-path: polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%);
}

.arrow-content {
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  clip-path: polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%);
}
</style>
